import styled, {keyframes} from "styled-components";
import {ColorButton} from "./color-button";
import {IconProps} from "../model";
import {ModalWrapper} from "./modal-wrapper";


interface ActionModalProps {
    open: boolean;
    onClose?: () => void;
    combo: number;
    high: number;
    middle: number;
    low: number;

}

export const UWinModal = ({open, onClose, combo, high, middle, low}: ActionModalProps) => {
    if (!open) return null;
    return (
        <ModalWrapper hamster={3}>
            <Container>
                <Title>
                    Congratulations!
                </Title>

                <Column>
                    <ScoreItem title={'Combo'} value={combo}/>
                    <ScoreItem title={'High'} value={high}/>
                    <ScoreItem title={'Middle'} value={middle}/>
                    <ScoreItem title={'Low'} value={low}/>
                </Column>
                <ColorButton
                    onClick={onClose!!}
                    variant={'primary'}
                    text={'Continue'}
                />
            </Container>
        </ModalWrapper>

    )
}


const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;


const Title = styled.div`
    color: #FFE600;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    text-transform: uppercase;
`


const Container = styled.div`
    display: flex;
    padding: 40px 16px 48px 16px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    animation: ${fadeIn} 0.3s ease-in-out;
    position: relative;
    gap: 32px;

`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
`


const CloseIconSWG = (props: IconProps) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L10 8.58579L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289C17.0976 3.68342 17.0976 4.31658 16.7071 4.70711L11.4142 10L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L10 11.4142L4.70711 16.7071C4.31658 17.0976 3.68342 17.0976 3.29289 16.7071C2.90237 16.3166 2.90237 15.6834 3.29289 15.2929L8.58579 10L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"
                  fill="white"/>
        </svg>
    )
}




const ScoreItem = (props: { title: string, value: number }) => (
    <ScoreItemRow>
        <ScoreItemRowText>
            {props.title}
        </ScoreItemRowText>
        <ScoreItemRowText>
            {props.value}
        </ScoreItemRowText>
    </ScoreItemRow>
)


const ScoreItemRow = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;
    gap: 5px;
    justify-content: space-between;
    border-bottom: 1px solid #A99804;
`


const ScoreItemRowText = styled.div`
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    text-transform: uppercase;
`

